<template>
  <!-- 按钮大小
       @author: 王汝鹏
       @date: 2019-9-15
   -->
  <div class="setting-item">
    <el-form-item label="按钮大小"> 
      <el-radio-group v-model="buttonSize" size="small">
        <el-radio-button 
            v-for="(item,index) in buttonSizeList" 
            :key="index"
            :label="item.label">
            {{item.value}}</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入按钮大小配置列表
import { buttonSizeList } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 按钮大小
     *  @description 将 buttonSize 字段映射到当前 buttonSize 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      buttonSize: { 
        parent: i => i.baseOption,
        attr: "buttonSize",
      }
    }),
  },
  data () {
    return {
        // 按钮大小配置列表
        buttonSizeList
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingButtonSize.vue